import { ComboboxData, Select as MantineSelect, SelectProps } from "@mantine/core";
import { IconChevronDown } from "@tabler/icons-react";
import { forwardRef, Ref } from "react";

import { Label } from "#shared/view/components/Label";

import classes from "./inputs/InputStyles.module.css";

export const SelectInput = forwardRef(
  (
    props: Omit<SelectProps, "data"> & {
      helper?: string;
      withEmptyData?: boolean;
      data: ComboboxData;
      size?: "sm" | "md";
    },
    ref: Ref<HTMLInputElement> | undefined,
  ) => {
    const { label, required, helper, data, withEmptyData, size = "md", ...rest } = props;

    const extendedData = data.map((item) => {
      if (typeof item === "string") {
        return item;
      }

      if ("group" in item) {
        return item;
      }

      return {
        value: item.value,
        label: item.label,
      };
    });

    const isGroupedData = extendedData.some((item) => typeof item !== "string" && "group" in item);

    if (withEmptyData && !isGroupedData) {
      extendedData.unshift({ value: "", label: "" });
    }

    return (
      <MantineSelect
        classNames={{
          input: size === "sm" ? classes.smallInput : classes.input,
        }}
        ref={ref}
        {...rest}
        data={extendedData}
        rightSection={<IconChevronDown size="1rem" />}
        styles={{
          section: { pointerEvents: "none" },
          input: {
            fontSize: size === "sm" ? 10 : 12,
          },
          option: {
            fontSize: size === "sm" ? 10 : 12,
          },
        }}
        required={required}
        withAsterisk={false}
        label={
          label && (
            <Label
              required={required}
              helper={helper}
              classNames={{
                label: size === "sm" ? classes.smallLabel : classes.label,
              }}
            >
              {label}
            </Label>
          )
        }
      />
    );
  },
);
